import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

export const Panel = (props) => (
    <>
        <Grid item xs={12} className="MuiPaper-elevation1 panel-container">
            {props.children}
        </Grid>
    </>
);

export const PanelHeader = (props) => (
    <>
        <Grid item xs={12} className="panel-header">
            <Typography variant="h5" gutterBottom className="panel-header-label">
                {props.children}
            </Typography>
        </Grid>
    </>
);

export const PanelContent = (props) => (
    <>
        <Grid item xs={12} className="panel-content-container">
            {props.children}
        </Grid>
    </>
);
